/// <reference path='../../interfaces/interfaces.d.ts' />

import Moment = moment.Moment;
import * as _ from 'lodash';

'use strict';

class FileSelectDirective {

    public restrict;
    public require;
    public scope;
    public replace;
    public template;

    constructor(
        private $timeout: ng.ITimeoutService,
        private Upload: any,
        private toaster: toaster.IToasterService,
        private bsLoadingOverlayService: IBsLoadingService
    ) {
        this.restrict = 'E';
        this.scope = {
            fmodel: '=',
            model: '=',
            pattern: '@',
            accept: '@',
            ifrequired: '@',
            title: '@'
        };
        this.replace = true;
        this.template = `
            <div class="form-input-upload">
                <button ng-if='ifrequired' required type="file" class="form-input" accept="{{accept}}" ngf-pattern="{{pattern}}" ngf-select="uploadFiles($file, $invalidFiles)" ng-model="model" ngf-max-size="5MB" name="{{title}}">Select File</button>
                <button ng-if='!ifrequired' type="file" class="form-input" accept="{{accept}}" ngf-pattern="{{pattern}}" ngf-select="uploadFiles($file, $invalidFiles)" ng-model="model" ngf-max-size="5MB">Select File</button>
                <br>
                <span class="file-name">
                    {{f.name}}
                    <span style="width:{{f.progress}}%;"></span>
                </span>
                <a ng-if="fmodel" ng-click="$parent.model = '';$parent.fmodel = ''; $parent.f = ''" title="Delete the file"><i class="material-icons">delete</i></a>
                <a ng-if="fmodel" href="{{fmodel}}" title="Download the file"><i class="material-icons">cloud_download</i></a>
            </div>`
    }

    public link = (scope: any, element: any, attr: any) => {
        if (scope.fmodel) {
      	    scope.model = scope.fmodel
        }
        scope.uploadFiles = (file, errFiles, fields) => {
            this.bsLoadingOverlayService.start({ referenceId: 'loader' })
            scope.f = file;
            scope.errFile = errFiles && errFiles[0];
            if (file) {
                file.upload = this.Upload.upload({
                    url: '/api/uploads/other',
                    data: { file: file }
                });

                file.upload.then((response) => {
                    this.$timeout(() => {
                        file.result = response.data;
                        scope.fmodel = response.data.url
                    });
                    this.bsLoadingOverlayService.stop({ referenceId: 'loader' })
                    this.toaster.pop('success', 'File Upload Successful')
                }, (response) => {
                    if (response.status > 0) {
                        scope.errorMsg = response.status + ': ' + response.data;
                        this.toaster.pop('error', 'File Upload Error', response.data)
                    }
                    this.bsLoadingOverlayService.stop({ referenceId: 'loader' })
                }, (evt) => {
                    file.progress = Math.min(100, parseInt((100.0 *
                        evt.loaded / evt.total).toString()));
                });
            } else {
                this.bsLoadingOverlayService.stop({ referenceId: 'loader' })
            }
            if(scope.errFile) {
                this.toaster.pop('error', 'Invalid File', scope.errFile.$error + ' must be ' + scope.errFile.$errorParam)
            }
        }
    };

    public static DirectiveFn($timeout, Upload, toaster, bsLoadingOverlayService): FileSelectDirective {
        return new FileSelectDirective($timeout, Upload, toaster, bsLoadingOverlayService);
    }
}

FileSelectDirective.DirectiveFn.$inject = ['$timeout', 'Upload', 'toaster', 'bsLoadingOverlayService'];

angular.module('beneple.global')
    .directive('fileSelect', FileSelectDirective.DirectiveFn);



// WEBPACK FOOTER //
// ./frontend/scripts/schemaForm/directives/file_select.directive.ts